import register from '@kpsys/angularjs-register';
import ReloaderService from './reloader.service';
import WalkerService from './walker.service';
import CurrentAuthService from './current-auth.service';
import ModalConversationInterceptorService from './modal-conversation-interceptor.service';
import ToasterService from './toaster-service';
import ProgressBarService from './progress-bar.service';
import FinishedResponseInteractionService from './finished-response-interaction.service';
import MailerService from './mailer.service';
import LoanRequestService from './loan-request.service';
import ActionRequestService from './action-request.service';
import DefinedActionPerformer from './defined-action-performer';
import LoanService from './loan.service';
import {UserFeedbackService} from './user-feedback.service';
import ActionRequestDataService from './action-request-data.service';
import SmsService from './sms.service';
import LocalizationsService from './localizations.service';
import {SearchService} from './search.service';
import {UrlStateManagerService} from './url-state-manager.service';

/**
 * @ngdoc module
 * @name portaro.services
 * @module portaro.services
 */

export default register('portaro.services')
    .service(ActionRequestDataService.serviceName, ActionRequestDataService)
    .service(ActionRequestService.serviceName, ActionRequestService)
    .service(WalkerService.serviceName, WalkerService)
    .service(ReloaderService.serviceName, ReloaderService)
    .service(CurrentAuthService.serviceName, CurrentAuthService)
    .service(MailerService.serviceName, MailerService)
    .service(ModalConversationInterceptorService.serviceName, ModalConversationInterceptorService)
    .service(ToasterService.serviceName, ToasterService)
    .service(ProgressBarService.serviceName, ProgressBarService)
    .service(FinishedResponseInteractionService.serviceName, FinishedResponseInteractionService)
    .service(LoanRequestService.serviceName, LoanRequestService)
    .service(DefinedActionPerformer.serviceName, DefinedActionPerformer)
    .service(LoanService.serviceName, LoanService)
    .service(UserFeedbackService.serviceName, UserFeedbackService)
    .service(SmsService.serviceName, SmsService)
    .service(LocalizationsService.serviceName, LocalizationsService)
    .service(SearchService.serviceName, SearchService)
    .service(UrlStateManagerService.serviceName, UrlStateManagerService)
    .name();
